export default "__VITE_ASSET__DtqM0D1X__"